export const lightThemeV2 = {
  'aI/applyBackground': '#92929212',
  'aI/applyDeleteHighlight': '#ed3f3f21',
  'aI/applyTextHighlight': '#1e96eb',
  'aI/applyTextHighlightBackground': '#1e96eb14',
  'aI/errorBackground': '#fff4f5',
  'aI/errorDetailBackground': '#ffffff99',
  'aI/errorText': '#ed3f3f',
  'aI/thinkingOutputBackground': '#0000000d',
  'aI/thinkingOutputText': '#000000a6',
  'aI/userTextBackground': '#f3f3f3',
  'adjustmentHandle/background': '#00000085',
  'adjustmentHandle/border': '#ffffff',
  'backlinks/blockBackgroundColor': '#9292920d',
  'backlinks/blockBorder': '#9292921a',
  'backlinks/blockHover': '#0000000d',
  'badge/believer': '#002742',
  'badge/free': '#29a3fa',
  'badge/pro': '#29a3fa',
  'block/callout/background/blue': '#f0f9ff',
  'block/callout/background/green': '#fbfef1',
  'block/callout/background/grey': '#f9f9f9',
  'block/callout/background/magenta': '#fefaff',
  'block/callout/background/orange': '#fff7ee',
  'block/callout/background/purple': '#f9f7ff',
  'block/callout/background/red': '#fff4f5',
  'block/callout/background/teal': '#eefffd',
  'block/callout/background/yellow': '#fdfcf4',
  'block/callout/icon/blue': '#53b2ef',
  'block/callout/icon/green': '#22bf07',
  'block/callout/icon/grey': '#cdcdcd',
  'block/callout/icon/magenta': '#cc4187',
  'block/callout/icon/orange': '#ffae63',
  'block/callout/icon/purple': '#7c3aed',
  'block/callout/icon/red': '#c83030',
  'block/callout/icon/teal': '#448e86',
  'block/callout/icon/yellow': '#fde047',
  'block/code/background': '#f7f8fa',
  'block/code/lineNum': '#b3b3b3',
  'block/comment/hanelActive': '#1e96eb05',
  'block/comment/highlightActive': '#1e96eb4d',
  'block/comment/highlightDefault': '#1e96eb14',
  'block/comment/highlightUnderline': '#1e96ebb2',
  'block/divider/divider': '#92929238',
  'block/footnote/numberBg': '#e6e6e6',
  'block/footnote/numberBgHover': '#1e96eb',
  'block/list/header': '#0077cb',
  'block/notSupportedBlock/background': '#ffffff',
  'block/notSupportedBlock/inlineBg/default': '#f3f3f3',
  'block/notSupportedBlock/inlineBg/hover': '#e6e6e6',
  'block/quote/bar': '#c2c1c5',
  'block/recordBlock/buttonBg': '#f3f3f3',
  'block/recordBlock/primary': '#f45353',
  'block/recordBlock/secordary': '#ff9a9a',
  'block/recordBlock/timelineIndeicator': '#ed3f3f',
  'brand/primary': '#1e96eb',
  'brand/primaryTint': '#1e96eb0a',
  'brand/secondary': '#7d91ff',
  'button/actionActive': '#1e96eb14',
  'button/badgesColor': '#ed3f3f',
  'button/buttonOverHover': '#ffffff',
  'button/checkBox': '#1e96eb',
  'button/disable': '#b3b3b3',
  'button/emptyIconBackground': '#0000000d',
  'button/error': '#ed3f3f',
  'button/iconButtonSolid': '#ffffff',
  'button/innerBlackBorder': '#0000001a',
  'button/primary': '#1e96eb',
  'button/pureWhiteText': '#ffffff',
  'button/secondary': '#ffffff',
  'button/success': '#44b931',
  'button/templateLabelBackground': '#1e96eb0a',
  'button/grabber/select': '#00000038',
  'button/grabber/default': '#0000001a',
  'button/mobile/aIActionBackground': '#252525',
  'button/mobile/deletedAction': '#ed3f3f',
  'button/sidebarButton/background': '#ffffff08',
  'button/siderbarPrimary/background': '#ffffffab',
  'button/signinbutton/background': '#ffffff',
  'button/windowsClose': '#c42b1c',
  'calendar/blue': '#4ab1fa',
  'calendar/green': '#44b931',
  'calendar/grey': '#b3b3b3',
  'calendar/magenta': '#f37fba',
  'calendar/orange': '#ffae63',
  'calendar/purple': '#9681ef',
  'calendar/red': '#f43f48',
  'calendar/teal': '#8be7dc',
  'calendar/yellow': '#fde047',
  'centerPeek/background': '#ffffff',
  'centerPeek/buttonBackground': '#ffffff',
  'centerPeek/icon': '#7a7a7a',
  'centerPeek/overlay': '#0000002b',
  'chatBlock/chatBlockBg': '#ffffff',
  'chatBlock/chatBlockBoder': '#e6e6e6',
  'chatBlock/chatBlockIcon': '#7a7a7a',
  'chatBlock/chatBlockText': '#141414',
  // Saturated status chips with white labels, identical in every theme.
  'chip/label/blue': '#2563eb',
  'chip/label/green': '#22c55e',
  'chip/label/grey': '#475569',
  'chip/label/magenta': '#c026d3',
  'chip/label/orange': '#f97316',
  'chip/label/purple': '#7c3aed',
  'chip/label/red': '#ef4444',
  'chip/label/teal': '#14b8a6',
  'chip/label/text': '#ffffff',
  'chip/label/white': '#e5e7eb',
  'chip/label/yellow': '#eab308',
  'chip/tag/blue': '#84cfff',
  'chip/tag/green': '#69b87d',
  'chip/tag/grey': '#b3b3b3',
  'chip/tag/orange': '#ff8c38',
  'chip/tag/purple': '#7c3aed',
  'chip/tag/red': '#ed3f3f',
  'chip/tag/teal': '#8be7dc',
  'chip/tag/yellow': '#facc15',
  'database/border': '#0000001a',
  'database/buttonBackground': '#ffffff',
  'database/cardHover': '#00000008',
  'database/filterHeaderFadeIn': '#ffffff',
  'database/filterHeaderFadeOut': '#ffffff08',
  'database/focusBackground': '#1e96eb0a',
  'database/textSecondary': '#00000085',
  'database/attachment/fileSolidBackground': '#e6e6e6',
  'dialog/background/primary': '#ffffff',
  'edgeless/alignment/edgeGuides': '#cc4187',
  'edgeless/alignment/guides': '#8b5cf6',
  'edgeless/axis': '#1d1d1f40',
  'edgeless/canvas': '#fbfbfa',
  'edgeless/frame/background/black': '#cdcdcd',
  'edgeless/frame/background/blue': '#e6f5ff',
  'edgeless/frame/background/green': '#f1fdf4',
  'edgeless/frame/background/grey': '#f3f3f3',
  'edgeless/frame/background/magenta': '#ffecf6',
  'edgeless/frame/background/orange': '#ffebd5',
  'edgeless/frame/background/purple': '#ede9ff',
  'edgeless/frame/background/red': '#fce5e6',
  'edgeless/frame/background/teal': '#e2fdf9',
  'edgeless/frame/background/white': '#ffffff',
  'edgeless/frame/background/yellow': '#fffbd5',
  'edgeless/frame/border/active': '#1e96eb',
  'edgeless/frame/border/default': '#0000002b',
  'edgeless/frame/fontColor/font': '#000000f2',
  'edgeless/grid': '#d4d4d0',
  'edgeless/gridBlock': '#1d1d1f12',
  'edgeless/gridCell': '#1d1d1f0a',
  'edgeless/gridSector': '#1d1d1f1c',
  'edgeless/group/background/background': '#ffffff',
  'edgeless/group/border/active': '#1e96eb',
  'edgeless/group/border/borderHint': '#8fd1ff',
  'edgeless/group/border/hover': '#1e96eb',
  'edgeless/group/fontColor/active': '#1e96eb',
  'edgeless/group/fontColor/default': '#00000085',
  'edgeless/group/fontColor/hover': '#1e96eb',
  'edgeless/group/fontColor/rename': '#000000',
  'edgeless/line/black': '#000000',
  'edgeless/line/blue': '#29a3fa',
  'edgeless/line/green': '#3cbc36',
  'edgeless/line/grey': '#929292',
  'edgeless/line/magenta': '#e660a4',
  'edgeless/line/orange': '#ff8c38',
  'edgeless/line/purple': '#6e52df',
  'edgeless/line/red': '#e11e41',
  'edgeless/line/teal': '#5cc7ba',
  'edgeless/line/white': '#ffffff',
  'edgeless/line/yellow': '#facc15',
  'edgeless/lock/locked': '#92929285',
  'edgeless/mindMap/line': '#000000',
  'edgeless/note/black': '#b3b3b3',
  'edgeless/note/blue': '#ceecff',
  'edgeless/note/green': '#c9f8c1',
  'edgeless/note/grey': '#e6e6e6',
  'edgeless/note/magenta': '#ffdaed',
  'edgeless/note/orange': '#ffc58f',
  'edgeless/note/purple': '#ddd6fe',
  'edgeless/note/red': '#fbb7b7',
  'edgeless/note/teal': '#c7f8f2',
  'edgeless/note/white': '#ffffff',
  'edgeless/note/yellow': '#fde68a',
  'edgeless/outside': '#efefec',
  'edgeless/palette/black': '#000000',
  'edgeless/palette/white': '#ffffff',
  'edgeless/palette/heavy/blue': '#1c70a5',
  'edgeless/palette/heavy/green': '#447756',
  'edgeless/palette/heavy/magenta': '#941555',
  'edgeless/palette/heavy/orange': '#b55309',
  'edgeless/palette/heavy/purple': '#5a21b6',
  'edgeless/palette/heavy/red': '#761717',
  'edgeless/palette/heavy/yellow': '#ac7400',
  'edgeless/palette/light/blueLight': '#e6f5ff',
  'edgeless/palette/light/greenLight': '#f1fdf4',
  'edgeless/palette/light/greyLight': '#e6e6e6',
  'edgeless/palette/light/magentaLight': '#ffecf6',
  'edgeless/palette/light/orangeLight': '#ffebd5',
  'edgeless/palette/light/purpleLight': '#ede9ff',
  'edgeless/palette/light/redLight': '#fce5e6',
  'edgeless/palette/light/yellowLight': '#fffbd5',
  'edgeless/palette/medium/blueMedium': '#84cfff',
  'edgeless/palette/medium/greenMedium': '#3cbc36',
  'edgeless/palette/medium/greyMedium': '#929292',
  'edgeless/palette/medium/magentaMedium': '#e96cab',
  'edgeless/palette/medium/orangeMedium': '#ff8c38',
  'edgeless/palette/medium/purpleMedium': '#6e52df',
  'edgeless/palette/medium/redMedium': '#fb7081',
  'edgeless/palette/medium/yellowMedium': '#fcd34d',
  'edgeless/selection/selectionMarqueeBackground': '#1e96eb14',
  'edgeless/selection/selectionMarqueeBorder': '#1e96eb',
  'edgeless/shape/black': '#000000',
  'edgeless/shape/blue': '#9fd9ff',
  'edgeless/shape/green': '#9bda91',
  'edgeless/shape/grey': '#cdcdcd',
  'edgeless/shape/magenta': '#ffc0e0',
  'edgeless/shape/orange': '#ffae63',
  'edgeless/shape/purple': '#d7cdff',
  'edgeless/shape/red': '#fecdd1',
  'edgeless/shape/teal': '#8be7dc',
  'edgeless/shape/white': '#ffffff',
  'edgeless/shape/yellow': '#fde047',
  'edgelessToolbar/highlightPen/body': '#fafafa',
  'edgelessToolbar/highlightPen/body1Linear1-1': '#00000000',
  'edgelessToolbar/highlightPen/body1Linear1-2': '#00000000',
  'edgelessToolbar/highlightPen/body1Linear1-3': '#000000',
  'edgelessToolbar/highlightPen/body1Linear2-1': '#ffffff00',
  'edgelessToolbar/highlightPen/body1Linear2-2': '#ffffff00',
  'edgelessToolbar/highlightPen/body1Linear2-3': '#ffffff00',
  'edgelessToolbar/highlightPen/body1Linear2-4': '#ffffff00',
  'edgelessToolbar/highlightPen/body2': '#f3f3f3',
  'edgelessToolbar/highlightPen/body2Linear1-1': '#00000000',
  'edgelessToolbar/highlightPen/body2Linear1-2': '#00000000',
  'edgelessToolbar/highlightPen/body2Linear1-3': '#000000',
  'edgelessToolbar/highlightPen/body2Linear2-1': '#00000000',
  'edgelessToolbar/highlightPen/body2Linear2-2': '#00000000',
  'edgelessToolbar/highlightPen/body2Linear2-3': '#00000000',
  'edgelessToolbar/highlightPen/body2Linear2-4': '#00000000',
  'edgelessToolbar/highlightPen/body2Linear2-5': '#00000000',
  'edgelessToolbar/highlightPen/bodyColorLinear-1': '#00000000',
  'edgelessToolbar/highlightPen/bodyColorLinear-2': '#000000fc',
  'edgelessToolbar/highlightPen/bodyColorLinear-3': '#000000c4',
  'edgelessToolbar/media/whiteVector': '#ffffff8f',
  'edgelessToolbar/note/background': '#ffffff',
  'edgelessToolbar/note/textColor': '#0000001a',
  'edgelessToolbar/others/background': '#ffffff1f',
  'edgelessToolbar/others/highlightLinearEnd': '#ffffff',
  'edgelessToolbar/others/highlightLinearStart': '#ffffff00',
  'edgelessToolbar/others/linearCenter': '#000000c4',
  'edgelessToolbar/others/linearEnd': '#0000001f',
  'edgelessToolbar/others/linearStart': '#ffffff1f',
  'edgelessToolbar/penEraser/eraserBlue-1': '#173654',
  'edgelessToolbar/penEraser/eraserBlue-2': '#effaff',
  'edgelessToolbar/penEraser/eraserBlue-3': '#1e96eb',
  'edgelessToolbar/penEraser/eraserBodyFill': '#f1f1f1',
  'edgelessToolbar/penEraser/eraserBodyHighlight': '#ffffff8f',
  'edgelessToolbar/penEraser/eraserBodyShade2': '#00000033',
  'edgelessToolbar/penEraser/eraserBodyShade3': '#ffffff',
  'edgelessToolbar/penEraser/eraserBorder': '#e7e7e7',
  'edgelessToolbar/penEraser/eraserBorder2': '#e3e2e4',
  'edgelessToolbar/penEraser/eraserClothHighlight': '#ffffff1c',
  'edgelessToolbar/penEraser/eraserClothShade2': '#0f0f0f',
  'edgelessToolbar/penEraser/eraserClothShade3': '#ffffff17',
  'edgelessToolbar/penEraser/eraserShadow': '#00000040',
  'edgelessToolbar/penEraser/penBackground': '#fafafa',
  'edgelessToolbar/penEraser/penBodyShade-1': '#00000033',
  'edgelessToolbar/penEraser/penBodyShade-2': '#0000001a',
  'edgelessToolbar/penEraser/penBodyShade-3': '#00000003',
  'edgelessToolbar/penEraser/penBodyShade-4': '#ffffff14',
  'edgelessToolbar/penEraser/penInlineShadow': '#ffffff00',
  'icon/activated': '#1e96eb',
  'icon/disable': '#b3b3b3',
  'icon/fileIconBorder': '#cdcdcd',
  'icon/monotone': '#7a7a7a',
  'icon/primary': '#7a7a7a',
  'icon/secondary': '#7a7a76',
  'icon/tertiary': '#cdcdcd',
  'icon/transparentBlack': '#00000085',
  'icon/fileIconColors/blue': '#0077cb',
  'icon/fileIconColors/green': '#1d9c07',
  'icon/fileIconColors/grey': '#1e1b4b',
  'icon/fileIconColors/magenta': '#e660a4',
  'icon/fileIconColors/purple': '#6e52df',
  'icon/fileIconColors/red': '#ed3f3f',
  'icon/fileIconColors/yellow': '#facc15',
  'input/background': '#ffffff',
  'input/scrollBar/handle': '#0000001a',
  'input/border/active': '#1e96eb',
  'input/border/default': '#00000073',
  'input/border/error': '#ed3f3f',
  'integrations/background/iconSolid': '#ffffff',
  'layer/background/hoverFilled': '#f5f5f5',
  'layer/black': '#000000',
  'layer/blackAlpha/10': '#0000001a',
  'layer/blackAlpha/30': '#0000004d',
  'layer/blackAlpha/50': '#00000080',
  'layer/blackAlpha/60': '#00000099',
  'layer/blackAlpha/80': '#000000cc',
  'layer/blackAlpha/90': '#000000e6',
  'layer/pureBlack': '#000000',
  'layer/pureWhite': '#ffffff',
  'layer/white': '#ffffff',
  'layer/insideBorder/blackBorder': '#00000073',
  'layer/insideBorder/border': '#00000017',
  'layer/insideBorder/primaryBorder': '#1e96eb',
  'layer/insideBorder/splitviewActived': '#0000002b',
  'layer/insideBorder/whiteBorder': '#ffffff8f',
  'layer/background/appChrome': '#f7f7f5',
  'layer/background/codeBlock': '#f5f5f5',
  'layer/background/edgelessGrid': '#e6e6e6',
  'layer/background/error': '#fff1f1',
  'layer/background/hoverOverlay': '#0000000d',
  'layer/background/selected': '#00000017',
  'layer/background/linkedDocOnEdgeless': '#ffffff',
  'layer/background/modal': '#00000066',
  'layer/background/modalWhite': '#ffffff2b',
  'layer/background/overlayPanel': '#ffffff',
  'layer/background/primary': '#ffffff',
  'layer/background/processing': '#eef2ff',
  'layer/background/secondary': '#f1f1ef',
  'layer/background/success': '#f1fdf4',
  'layer/background/tertiary': '#eaeae7',
  'layer/background/translucentUI': '#ffffffb8',
  'layer/background/warning': '#fff7ee',
  'layer/background/mobile/iOSControl': '#000000',
  'layer/background/mobile/modal': '#0000002b',
  'layer/background/mobile/primary': '#f5f5f5',
  'layer/background/mobile/secondary': '#ffffff',
  'layer/background/mobile/tertiary': '#e6e6e6',
  'layer/whiteAlpha/10': '#ffffff1a',
  'layer/whiteAlpha/30': '#ffffff4d',
  'layer/whiteAlpha/50': '#ffffff80',
  'layer/whiteAlpha/60': '#ffffff99',
  'layer/whiteAlpha/80': '#ffffffcc',
  'layer/whiteAlpha/90': '#ffffffe6',
  'loading/background': '#0000001a',
  'loading/backgroundLayer': '#92929238',
  'loading/foreground': '#1e96eb',
  'loading/imageLoadingBackground': '#92929238',
  'loading/imageLoadingLayer': '#ffffff8f',
  'others/warnLabel/black': '#000000',
  'others/warnLabel/yellow': '#facc15',
  'pagelist/hoverBorder': '#e6e6e6',
  'portrait/localPortrait': '#00000038',
  'portrait/localPortraitBackground': '#0000001a',
  'radio/disable': '#cdcdcd',
  'radio/active/chekced': '#1e96eb',
  'radio/active/default': '#7a7a7a',
  'readwise/quoteBackground': '#f9f9f9',
  'readwise/quoteDivider': '#1e96eb',
  'segment/background': '#0000000d',
  'segment/button': '#ffffff',
  'selfhost/portrait/localPortraitBackground': '#0000000d',
  'selfhost/button/disable': '#7a7a7a',
  'selfhost/button/primary': '#141414',
  'selfhost/button/secondary': '#ffffff',
  'selfhost/button/sidebarButton/bg/hover': '#0000000d',
  'selfhost/button/sidebarButton/bg/select': '#0000000d',
  'selfhost/icon/buttonIcon': '#ffffff',
  'selfhost/icon/buttonIconError': '#ffffff',
  'selfhost/icon/disable': '#b3b3b3',
  'selfhost/icon/primary': '#141414',
  'selfhost/icon/secondary': '#7a7a7a',
  'selfhost/icon/tertiary': '#b3b3b3',
  'selfhost/layer/background/hoverOverlay': '#ffffff3b',
  'selfhost/layer/background/primary': '#ffffff',
  'selfhost/layer/background/secondary': '#f9f9f9',
  'selfhost/layer/background/sidebarBg/sidebarBg': '#f9f9f9',
  'selfhost/layer/border/border': '#141414',
  'selfhost/progress/error': '#ed3f3f',
  'selfhost/progress/primary': '#141414',
  'selfhost/text/placeholder': '#b3b3b3',
  'selfhost/text/button/error': '#ffffff',
  'selfhost/text/button/primary': '#ffffff',
  'selfhost/text/sidebar/primary': '#141414',
  'selfhost/text/sidebar/secondary': '#252525',
  'selfhost/toggle/backgroundDisable': '#e6e6e6',
  'selfhost/toggle/backgroundOff': '#cdcdcd',
  'selfhost/toggle/backgroundOn': '#141414',
  'selfhost/toggle/foreground': '#ffffff',
  'selfhost/toggle/foregroundDisable': '#f9f9f9',
  'shadow/active': '0px 0px 0px 2px rgba(30, 150, 235, 0.30)',
  'shadow/button':
    '0px 0px 1px 0px rgba(0, 0, 0, 0.12), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
  'shadow/floatButton':
    '0px 0px 10px rgba(0, 0, 0, 0.05), 0px 0px 0px 0.5px rgba(0, 0, 0, 0.1)',
  'shadow/largeButton': '0px 12px 21px 4px rgba(30, 150, 235, 0.15)',
  'shadow/level1': '0px 0px 4px 0px rgba(66, 65, 73, 0.14)',
  'shadow/level2': '0px 0px 12px 0px rgba(66, 65, 73, 0.18)',
  'shadow/level3': '0px 0px 20px 0px rgba(66, 65, 73, 0.22)',
  'shadow/menu':
    '0px 10px 18px rgba(0,0,0,0.14), 0px -1px 12px rgba(0,0,0,0.08)',
  'shadow/note/box':
    '0px 0px 4px 0px rgba(0, 0, 0, 0.14), 0px 2px 12px 0px rgba(0, 0, 0, 0.14)',
  'shadow/note/film': '10px 10px 0px 6px #000, 0px 0px 0px 6px #000',
  'shadow/note/float':
    '0px 0px 32px 0px rgba(0, 0, 0, 0.09), 0px 0px 3px 0px rgba(0, 0, 0, 0.10)',
  'shadow/note/paper':
    '0px 2px 4px 0px rgba(0, 0, 0, 0.05), 0px 0px 0px 10px #FFF, 0px 3px 6px 12px rgba(0, 0, 0, 0.14)',
  'shadow/note/sticker':
    '0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 26px 18px -20px rgba(0, 0, 0, 0.10)',
  'shadow/overlay':
    '0px 1px 6px 0px rgba(0, 0, 0, 0.16), 0px 8px 14px 0px rgba(0, 0, 0, 0.08)',
  'shadow/overlayPanel':
    '0px 1px 6px rgba(0,0,0,0.16), 0px 8px 14px rgba(0,0,0,0.08)',
  'shadow/popover':
    '0px 0px 30px rgba(75, 75, 75, 0.2), 0px 0px 4px rgba(75, 75, 75, 0.3), inset 0px 0px 0px rgba(227, 226, 228, 1)',
  'shadow/toolbar': '0px 6px 16px #00000024',
  'skeleton/skeleton': '#e6e6e6',
  'slashMenu/background': '#ffffff',
  'status/error': '#ed3f3f',
  'status/processing': '#2776ff',
  'status/success': '#44b931',
  'status/warning': '#eb4335',
  'switch/buttonBackground/active': '#ffffff',
  'switch/buttonBackground/hover': '#0000000d',
  'switch/fontColor/primary': '#141414',
  'switch/fontColor/secondary': '#7a7a7a',
  'switch/fontColor/tertiary': '#929292',
  'switch/iconColor/active': '#565656',
  'switch/iconColor/default': '#929292',
  'switch/switchBackground/background': '#f3f3f3',
  'tab/divider/divider': '#00000012',
  'tab/divider/indicator': '#1e96eb',
  'tab/fontColor/active': '#141414',
  'tab/fontColor/default': '#b3b3b3',
  'tab/fontColor/hover': '#141414',
  'tab/iconColor/active': '#565656',
  'tab/iconColor/default': '#b3b3b3',
  'tab/iconColor/hover': '#565656',
  'tab/tabBackground/active': '#ffffff',
  'tab/tabBackground/default': '#f3f3f3',
  'tab/tabBackground/hover': '#f3f3f3',
  'table/border': '#0000001a',
  'table/focusBackground': '#1e96eb0a',
  'table/focusBorder': '#1e96eb',
  'table/textSecondary': '#00000085',
  'table/headerBackground/blue': '#f0f9ff',
  'table/headerBackground/default': '#ffffff',
  'table/headerBackground/green': '#efffec',
  'table/headerBackground/grey': '#f5f5f5',
  'table/headerBackground/headerColor': '#f3f3f3',
  'table/headerBackground/orange': '#fff7ee',
  'table/headerBackground/purple': '#f7f5ff',
  'table/headerBackground/red': '#fff4f5',
  'table/headerBackground/teal': '#eefffd',
  'table/headerBackground/yellow': '#fffded',
  'table/indicator/activated': '#1e96eb',
  'table/indicator/border': '#e6e6e6',
  'table/indicator/drag': '#0000002b',
  'table/indicator/hover': '#0000000d',
  'table/indicator/pointerActive': '#ffffff',
  'table/indicator/pointerDefault': '#b3b3b3',
  'text/disable': '#7a7a7a',
  'text/emphasis': '#1e96eb',
  'text/link': '#035f9f',
  'text/listDotAndNumber': '#0077cb',
  'text/placeholder': '#6b6b67',
  'text/primary': '#141414',
  'text/pureWhite': '#ffffff',
  'text/secondary': '#5c5c59',
  'text/tertiary': '#6b6b67',
  'text/highlight/border': '#00000038',
  'text/highlight/bg/blue': '#daf0ff',
  'text/highlight/bg/green': '#f0fccb',
  'text/highlight/bg/grey': '#e6e6e6',
  'text/highlight/bg/magenta': '#ffecf6',
  'text/highlight/bg/orange': '#ffebd5',
  'text/highlight/bg/purple': '#ede9ff',
  'text/highlight/bg/red': '#fce5e6',
  'text/highlight/bg/teal': '#c7f8f2',
  'text/highlight/bg/yellow': '#fff9b6',
  'text/highlight/fg/blue': '#003c67',
  'text/highlight/fg/green': '#225c18',
  'text/highlight/fg/grey': '#7a7a7a',
  'text/highlight/fg/magenta': '#941555',
  'text/highlight/fg/orange': '#db7123',
  'text/highlight/fg/purple': '#7c3aed',
  'text/highlight/fg/red': '#c83030',
  'text/highlight/fg/teal': '#0e4841',
  'text/highlight/fg/yellow': '#ac7400',
  'toast/cardLayer/second': '#f9f9f9',
  'toast/cardLayer/third': '#f5f5f5',
  'toast/iconState/error': '#ed3f3f',
  'toast/iconState/regular': '#0077cb',
  'toast/iconState/success': '#44b931',
  'toast/overlay/secondary': '#00000008',
  'toast/overlay/tertiary': '#0000000d',
  'toggle/background': '#1e96eb',
  'toggle/backgroundDisable': '#b3b3b3',
  'toggle/backgroundOff': '#929292',
  'toggle/foreground': '#ffffff',
  'toggle/foregroundDisable': '#e6e6e6',
  'tooltips/background': '#000000',
  'tooltips/foreground': '#ffffff',
  'tooltips/secondaryBackground': '#ffffff2b',
  'workspacePicker/border': '#e6e6e6',
  'workspacePicker/secondaryBackground': '#9292921a',
  'tableOfContent/background': '#ffffff',
};

export type AffineThemeV2 = typeof lightThemeV2;
export type AffineThemeKeyV2 = keyof AffineThemeV2;
